// GENERATED by scripts/bake-card-thumbs.mjs - do not edit by hand.
// Card-art files (assets/cards/<name>) that have baked thumbnails in assets/cards/thumb/ and thumb-s/.
export const CARD_THUMB_WIDTH = 448;
export const CARD_THUMBS = new Set([
  "1_Cannon.png",
  "1_Hypermarine.png",
  "1_Rocketship.png",
  "1_a9grizzly.png",
  "1_a9pigeon.png",
  "1_a9piranha.png",
  "1_ambush.png",
  "1_antishade.png",
  "1_apostateloaf.png",
  "1_bastionlock.png",
  "1_claimingpillar.png",
  "1_concentrate.png",
  "1_congressmodule.png",
  "1_defectiveloaf.png",
  "1_delvingpillar.png",
  "1_devilpatrol.png",
  "1_enforcervulture.png",
  "1_experimentalmetamorphosis.png",
  "1_fodder.png",
  "1_forcedoverstimulation.png",
  "1_forgottenloaf.png",
  "1_hacker.png",
  "1_harvestingpillar.png",
  "1_hothand.png",
  "1_hyperdevilpatrol.png",
  "1_hyperpanzer.png",
  "1_hypershade.png",
  "1_hypertesla.png",
  "1_invasioncapsule.png",
  "1_lootingvulture.png",
  "1_mentalextraction.png",
  "1_monitorlock.png",
  "1_orchestra.png",
  "1_parasitevulture.png",
  "1_pinkberet.png",
  "1_precisionstrike.png",
  "1_preserverlock.png",
  "1_processingpillar.png",
  "1_pulp.png",
  "1_rejectedloaf.png",
  "1_retreatprotocol.png",
  "1_sentinallock.png",
  "1_shade.png",
  "1_stickman.png",
  "1_thesalvagecompany.png",
  "1_wheeliebomber.png",
  "2_concentrate.png",
  "2_devilpatrol.png",
  "2_dronecommand.png",
  "2_slingmodul.png",
  "2_thesalvagecompany.png",
  "3_thesalvagecompany.png",
  "Marine_1.png",
  "Siege_Tank_1.png",
  "Tesla_1.png",
  "gold_2_dronecommand.png",
  "gold_2_slingmodul.png",
  "gold_a9grizzly.png",
  "gold_a9pigeon.png",
  "gold_a9piranha.png",
  "gold_ambush.png",
  "gold_antishade.png",
  "gold_apostateloaf.png",
  "gold_bastionlock.png",
  "gold_cannon.png",
  "gold_claimingpillar.png",
  "gold_concentrate.png",
  "gold_congressmodule.png",
  "gold_defectiveloaf.png",
  "gold_delvingpillar.png",
  "gold_devilpatrol.png",
  "gold_enforcervulture.png",
  "gold_experimentalmetamorphosis.png",
  "gold_fodder.png",
  "gold_forcedoverstimulation.png",
  "gold_forgottenloaf.png",
  "gold_hacker.png",
  "gold_harvestingpillar.png",
  "gold_hothand.png",
  "gold_hyperdevilpatrol.png",
  "gold_hypermarine.png",
  "gold_hyperpanzer.png",
  "gold_hypershade.png",
  "gold_hypertesla.png",
  "gold_lootingvulture.png",
  "gold_marine.png",
  "gold_mentalextraction.png",
  "gold_monitorlock.png",
  "gold_orchestra.png",
  "gold_parasitevulture.png",
  "gold_pinkberet.png",
  "gold_precisionstrike.png",
  "gold_preserverlock.png",
  "gold_processingpillar.png",
  "gold_pulp.png",
  "gold_rejectedloaf.png",
  "gold_retreatprotocol.png",
  "gold_rocketship.png",
  "gold_sentinallock.png",
  "gold_shade.png",
  "gold_siegetank.png",
  "gold_stickman.png",
  "gold_tesla.png",
  "gold_thesalvagecompany.png",
  "gold_wheeliebomber.png"
]);
